<template>
  <div>
    <div class="mainbody">
      <!--      <code>{{ products }}</code>-->
      <!--quickModal START-->
      <div class="isloader" v-if="isLoading">
        <img src="@/assets/images/loader-zig.gif" alt="search" />
      </div>

      <div
        id="quickModal"
        class="modal quickModal fade"
        tabindex="-1"
        role="dialog"
      >
        <div class="modal-dialog modal-lg">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal">
                &times;
              </button>
              <div class="row">
                <div class="col-md-5">
                  <div class="breadcum mb15">
                    <i class="fa fa-circle-o" aria-hidden="true"></i>
                    {{ get_category_name }}
                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                    {{ modalProductData.name }}
                  </div>
                  <div class="right-border img-max-height">
                    <img
                      v-if="
                        changeModalGallery_image ===
                          modalProductData.featured_image
                      "
                      v-bind:src="
                        fileUrl +
                          'uploads/products/' +
                          modalProductData.featured_image
                      "
                      class="img-responsive"
                    />
                    <img
                      v-else
                      v-bind:src="
                        fileUrl + 'uploads/products/' + changeModalGallery_image
                      "
                      class="img-responsive"
                    />
                  </div>
                </div>
                <div class="col-md-7">
                  <h3 class="m-p-title" v-if="globalLanguage == 'EN'">
                    {{ modalProductData.name }} {{ modalProductData.strength }}
                  </h3>
                  <h3 class="m-p-title" v-else>
                    {{ modalProductData.name_bn }}
                    {{ modalProductData.strength }}
                  </h3>
                  <!--<div class="rating">-->
                  <!--&lt;!&ndash;<i class="fa fa-star"></i> <i class="fa fa-star"></i> <i class="fa fa-star"></i> <i&ndash;&gt;-->
                  <!--&lt;!&ndash;class="fa fa-star"></i> <i class="fa fa-star"></i>&ndash;&gt;-->
                  <!--<span> </span>-->
                  <!--</div>-->
                  <div class="code">
                    Code: <b>#{{ modalProductData.id }}</b>
                  </div>
                  <div class="code">
                    Availability:
                    <span
                      class="green-color"
                      v-if="modalProductData.stock_quantity > 0"
                      >In Stock</span
                    >
                    <span class="red-color" v-else>Out of Stock</span>
                  </div>
                  <div
                    class="code mt10"
                    v-if="modalProductData.dosages_description"
                  >
                    Type: {{ modalProductData.dosages_description }}
                  </div>
                  <div class="code" v-if="modalProductData.strength">
                    Strength: {{ modalProductData.strength }}
                  </div>
                  <div class="code  " v-if="modalProductData.generic_name">
                    Generic Name: {{ modalProductData.generic_name }}
                  </div>

                  <div class="price mt5">
                    <h3 class="running base-color">
                      {{
                        (
                          modalProductData.price - modalProductData.discount
                        ).toFixed(2)
                      }}
                      &#8364;
                    </h3>
                    <span
                      class="discounted"
                      v-if="modalProductData.discount > 0"
                      ><span>
                        {{ modalProductData.price.toFixed(2) }} &#8364;</span
                      >
                    </span>
                    <!--{{//Math.round(modalProductData.discount) }}% Off -->
                  </div>
                  <div class="quick-modal-actions">
                    <div class="quick-modal-stepper">
                      <div class="quantity mt15 clearfix">
                        <div>Quantity</div>
                        <div class="pull-left">
                          <span
                            variant="info"
                            @click="decrement(modalProductData.id)"
                            ><img
                              src="@/assets/images/minus-yellow.png"
                              width="24px"
                          /></span>
                        </div>
                        <input
                          class="pull-left text-center"
                          type="text"
                          min="1"
                          :value="quantity"
                          readonly
                        />
                        <div class="pull-left">
                          <span
                            variant="info"
                            @click="increment(modalProductData.id)"
                            ><img src="@/assets/images/plusorange.png" width="24px"
                          /></span>
                        </div>
                      </div>
                    </div>
                    <div class="quick-modal-cart-action">
                      <button
                        type="button"
                        class="btn btn-add-to-cart btn-sm    mt30"
                        v-if="
                          modalProductData.stock_quantity > 0 &&
                            globalLanguage == 'EN'
                        "
                        @click="createCartsModal()"
                      >
                        Add to Bag
                      </button>
                      <button
                        type="button"
                        class="btn  btn-add-to-cart bn btn-sm mt30"
                        v-if="
                          modalProductData.stock_quantity > 0 &&
                            globalLanguage != 'EN'
                        "
                        @click="createCartsModal()"
                      >
                        ব্যাগে যোগ করুন
                      </button>
                    </div>
                  </div>

                </div>
                <div class="col-md-12 pd0">
                  <div v-if="modalProductData.gp_image_1">
                    <hr />
                    <div class="ml15 pull-left  ">
                      <div
                        class="gallery-img"
                        v-if="modalProductData.gp_image_1"
                        @click="galleryImg(modalProductData.gp_image_1)"
                      >
                        <img
                          v-bind:src="
                            fileUrl +
                              'uploads/products/' +
                              modalProductData.gp_image_1
                          "
                          class="img-responsive"
                        />
                      </div>
                      <div
                        class="gallery-img"
                        v-if="modalProductData.gp_image_2"
                        @click="galleryImg(modalProductData.gp_image_2)"
                      >
                        <img
                          v-bind:src="
                            fileUrl +
                              'uploads/products/' +
                              modalProductData.gp_image_2
                          "
                          class="img-responsive"
                        />
                      </div>
                      <div
                        class="gallery-img"
                        v-if="modalProductData.gp_image_3"
                        @click="galleryImg(modalProductData.gp_image_3)"
                      >
                        <img
                          v-bind:src="
                            fileUrl +
                              'uploads/products/' +
                              modalProductData.gp_image_3
                          "
                          class="img-responsive"
                        />
                      </div>
                      <div
                        class="gallery-img"
                        v-if="modalProductData.gp_image_4"
                        @click="galleryImg(modalProductData.gp_image_4)"
                      >
                        <img
                          v-bind:src="
                            fileUrl +
                              'uploads/products/' +
                              modalProductData.gp_image_4
                          "
                          class="img-responsive"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="clearfix"></div>
                  <ul
                    class="nav nav-tabs m-tab-menu mt0"
                    v-if="modalProductData.description"
                  >
                    <!--                  <li ><a data-toggle="tab" href="#Description">Reviews</a></li>-->
                    <li class="active">
                      <a data-toggle="tab" href="#Reviews">Description</a>
                    </li>
                  </ul>
                  <div class="tab-content ml15">
                    <div id="Description" class="tab-pane "></div>
                    <div
                      id="Reviews"
                      class="tab-pane fade in active"
                      style="padding-right: 15px;"
                    >
                      <br />
                      <div v-html="modalProductData.description"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="related-products-section"
                v-if="related_products && related_products.length > 0"
              >
                <hr />
                <h4 class="related-title" v-if="globalLanguage == 'EN'">
                  You May Also Like
                </h4>
                <h4 class="related-title" v-else>আপনার পছন্দ হতে পারে</h4>
                <div class="related-products-scroll">
                  <div
                    class="related-product-card"
                    v-for="rp in related_products"
                    :key="rp.id"
                  >
                    <div
                      class="related-product-img"
                      style="cursor:pointer;"
                      @click="addOrIncrementRelatedCart(rp)"
                    >
                      <img

                        v-bind:src="
                          fileUrl + 'uploads/products/' + rp.featured_image
                        "
                        :alt="rp.name"
                        class="img-responsive"
                      />
                      <ProductCartControl
                        control-class="related-cart-control"
                        :product-id="rp.id"
                        :language="globalLanguage"
                        :quantity="getCartQuantity(rp.id)"
                        :in-cart="hasCartQuantity(rp.id)"
                        @add="addRelatedToCart(rp)"
                        @decrement="cartDecrement(rp.id)"
                        @increment="cartIncrement(rp.id)"
                      />
                    </div>
                    <div
                      class="related-product-info"
                      style="cursor:pointer;"
                      @click="viewRelatedProduct(rp.id)"
                    >
                      <div class="related-product-price">
                        {{ (rp.price - rp.discount).toFixed(2) }} &#8364;
                      </div>
                      <div
                        class="related-product-name"
                        v-if="globalLanguage == 'EN'"
                      >
                        {{
                          rp.name.length > 18
                            ? rp.name.substring(0, 18) + "..."
                            : rp.name
                        }}
                      </div>
                      <div class="related-product-name" v-else>
                        {{
                          rp.name_bn.length > 18
                            ? rp.name_bn.substring(0, 18) + "..."
                            : rp.name_bn
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--quickModal END-->

      <div class="container-fluid">
        <div>
          <img
            v-if="category.banner"
            v-bind:src="fileUrl + 'uploads/cat_images/' + category.banner"
            class="img-responsive categorybanner"
          />
      <div v-if="sub_categories.length > 0">
        <div class="row categories category-block">
          <div>
            <div class="breadcum mt15">
              <i aria-hidden="true" class="fa fa-circle-o"></i>
              <template v-if="breadcrumb.length > 0">
                <span v-for="(crumb, i) in breadcrumb" :key="crumb.slug">
                  <i aria-hidden="true" class="fa fa-angle-right"></i>
                  <router-link
                    v-if="i < breadcrumb.length - 1"
                    :to="'/' + crumb.slug"
                    >{{
                      globalLanguage == "EN" ? crumb.name : crumb.name_bn
                    }} </router-link
                  >
                  <span v-else style="font-weight: 700;">{{
                    globalLanguage == "EN" ? crumb.name : crumb.name_bn
                  }} </span>
                </span>
              </template>
              <template v-else>
                <i aria-hidden="true" class="fa fa-angle-right"></i>
                <span style="font-weight: 700;" v-if="globalLanguage == 'EN'">
                  {{ category.cat_name }} </span
                >
                <span style="font-weight: 700;" v-else>
                  {{ category.cat_name_bn }} </span
                >
              </template>
            </div>
          </div>

          <div
            class="col-lg-3 col-md-3 col-sm-4 col-xs-6 col-lg-custom-5 col"
            v-for="category in sub_categories"
            v-if="!['popular', 'flash-sales'].includes(category.slug)"
            :key="category.id"
          >
            <div class="bindarea">
              <router-link :to="{ path: '/' + category.slug }" class="cat">
                <div style="min-height: 130px;">
                  <img
                    v-if="category.cat_img"
                    v-bind:src="
                      fileUrl + 'uploads/cat_images/' + category.cat_img
                    "
                    :alt="category.cat_name"
                  />
                  <img
                    v-else
                    src="@/assets/images/default.png"
                    :alt="category.cat_name"
                  />
                </div>
                <div class="cname" v-if="globalLanguage == 'EN'">
                  {{
                    category.cat_name.length > 15
                      ? category.cat_name.substring(0, 15) + "..."
                      : category.cat_name
                  }}
                </div>
                <div class="cname" v-else>
                  {{
                    category.cat_name_bn.length > 15
                      ? category.cat_name_bn.substring(0, 15) + "..."
                      : category.cat_name_bn
                  }}
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="products-list" v-else>
        <div class="col-lg-12 col breadcum mt15">
          <i aria-hidden="true" class="fa fa-circle-o"></i>
          <template v-if="breadcrumb.length > 0">
            <span v-for="(crumb, i) in breadcrumb" :key="crumb.slug">
              <i aria-hidden="true" class="fa fa-angle-right"></i>
              <router-link
                v-if="i < breadcrumb.length - 1"
                :to="'/' + crumb.slug"
                >{{
                  globalLanguage == "EN" ? crumb.name : crumb.name_bn
                }}  </router-link
              >
              <span v-else style="font-weight: 700;">{{
                globalLanguage == "EN" ? crumb.name : crumb.name_bn
              }}</span>
            </span>
          </template>
          <template v-else>
            <i aria-hidden="true" class="fa fa-angle-right"></i>
            <span style="font-weight: 700;" v-if="globalLanguage == 'EN'">
              {{ category.cat_name }}</span
            >
            <span style="font-weight: 700;" v-else>
              {{ category.cat_name_bn }}</span
            >
          </template>
        </div>
        <div
          class="col-lg-12 col text-center"
          v-show="isLoading == false && products.length < 1"
        >
          <img
            src="@/assets/images/icons/noproduct.png"
            alt="No Product Found"
            style="display: block; margin: 0 auto;"
          />
        </div>
        <div class="col-lg-12 col " v-if="category_image != ''">
          <img
            v-bind:src="fileUrl + 'uploads/cat_images/' + category_image"
            class="img-responsive"
          />
        </div>
        <div
          class="col-lg-3 col-md-3 col-sm-4 col-xs-6 col-lg-custom-5 col"
          v-for="(product, index) in products"
        >
          <div
            class="product"
            v-bind:class="{ outStock: product.stock_quantity < 1 }"
          >
            <div class="discount-ribbon" v-if="product.discount > 0">
              {{ product.discount }} &#8364; <i> OFF</i>
            </div>
            <div class="img-fix-area">
              <div
                class="wishlist-toggle"
                :class="{ active: inWishlist(product.id) }"
                @click="toggleWishlistClick(product)"
              >
                <i
                  class="fa"
                  :class="inWishlist(product.id) ? 'fa-heart' : 'fa-heart-o'"
                ></i>
              </div>
              <div style="cursor:pointer;"
                @click="addOrIncrementCart(index, product.id)">
              <img
                v-if="product.featured_image"
                v-bind:src="
                  fileUrl + 'uploads/products/' + product.featured_image
                "
                :alt="product.name"
                class="img-responsive"

              />
              </div>
              <div :id="'q_product_' + product.id">
                <div class="cartsection">
                  <div class="qbag">
                    <div
                      v-if="globalLanguage == 'EN'"
                      style="margin-top: 15px;color: #fff;"
                    >
                      In Bag
                    </div>
                    <div v-else style="margin-top: 15px;color: #fff;">
                      টি ব্যাগে
                    </div>
                  </div>
                  <!-- <span
                    v-if="globalLanguage == 'EN'"
                    class="quick"
                    @click="quickView(index)"
                    data-toggle="modal"
                    data-target="#quickModal"
                  >Quick View</span
                  >
                  <span
                    v-else
                    class="quick"
                    @click="quickView(index)"
                    data-toggle="modal"
                    data-target="#quickModal"
                  >বিস্তারিত</span
                  > -->
                </div>

                <!--                <button type="button" @click="quickView(index)" data-toggle="modal" data-target="#quickModal"-->
                <!--                  class="btn btn-sm  btn-quick animated fadeIn ">-->
                <!--                  Quick view-->
                <!--                </button>-->
              </div>
            </div>
            <div class="summary">
              <div class="price">
                <span class="running">
                  {{ (product.price - product.discount).toFixed(2) }} &#8364;
                </span>
                <!--<span class="running" > {{ product.price }} &#8364;</span>-->
                <span class="discounted" v-if="product.discount > 0">
                  {{ product.price.toFixed(2) }} &#8364;
                </span>
                <span v-else>&nbsp;</span>
              </div>
              <h3
                class="name"
                @click="quickView(index)"
                data-toggle="modal"
                data-target="#quickModal"
                style="cursor:pointer;"
                v-if="globalLanguage == 'EN'"
              >
                {{
                  product.name.length > 20
                    ? product.name.substring(0, 20) + "..."
                    : product.name
                }}

                {{ product.strength }}

                <!-- <span class="stock-out" v-if="product.stock_quantity < 1"
                ><br/>Out Of Stock</span
                > -->
              </h3>
              <h3
                class="name bn"
                @click="quickView(index)"
                data-toggle="modal"
                data-target="#quickModal"
                style="cursor:pointer;"
                v-else
              >
                {{
                  product.name_bn.length > 20
                    ? product.name_bn.substring(0, 20) + "..."
                    : product.name_bn
                }}
                {{ product.strength }}

                <!-- <span class="stock-out" v-if="product.stock_quantity < 1"
                ><br/>স্টক আউট
                </span> -->
              </h3>
              <div class="weight">
                {{ product.unit_quantity }} {{ product.unit }}
              </div>

              <ProductCartControl
                v-if="product.stock_quantity > 0"
                control-class="category-cart-control"
                :product-id="product.id"
                :language="globalLanguage"
                :quantity="getCartQuantity(product.id)"
                :in-cart="hasCartQuantity(product.id)"
                @add="createCarts(index, product.id)"
                @decrement="cartDecrement(product.id)"
                @increment="cartIncrement(product.id)"
              />
              <div class="button-label" v-else>
                <!-- <div class="btn-group d-block newBtn outSBtn">
                  <button
                    v-if="globalLanguage == 'EN'"
                    type="button"
                    data-toggle="modal"
                    data-target="#requestModal"
                    @click="assignProduct(product.name)"
                    class="btn btn-sm btn-block add-to-cart-btn"
                  >
                    CALL FOR ORDER
                  </button>
                  <button
                    v-else
                    type="button"
                    data-toggle="modal"
                    data-target="#requestModal"
                    @click="assignProduct(product.name)"
                    class="btn btn-sm btn-block add-to-cart-btn bn"
                  >
                    অর্ডার করতে কল করুন
                  </button>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
        </div>
      </div>
            <CartData
        :carts="carts"
        :sum-cart-total="sum_cart_total || 0"
        :file-url="fileUrl"
        :global-language="globalLanguage"
        @remove-cart-item="removeCartItem"
        @cart-increment="cartIncrement"
        @cart-decrement="cartDecrement"
      />
    </div>
    <div class="mobilemenu">
      <div class="same">
        <a href="/" class="icon-bottom">
          <img src="@/assets/images/icons/home-ash.png" width="31px" />
        </a>
      </div>
      <div class="gocheckout" v-if="carts.length > 0">
        <router-link to="/checkout">
          GO CHECKOUT
        </router-link>
      </div>
      <div class="gocheckout start" @click="toogleNav()" v-else>
        <span>
          START SHOPPING
        </span>
      </div>
      <div class="mybag same carts">
        <span>
          <span class="badge">0</span>
          <img
            class="iconbag"
            src="@/assets/images/icons/bag.png"
            alt="Shopping-bag"
            height="31px"
          />
        </span>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal requestModal fade" id="requestModal" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
            <h4 class="modal-title" v-if="globalLanguage == 'EN'">
              Request For Stock this product
            </h4>
            <h4 class="modal-title" v-else>প্রোডাক্টটি স্টক রিকোয়েস্ট করুন</h4>
          </div>
          <div class="modal-body">
            <div class="form-group mt15">
              <input
                type="text"
                class="form-control"
                v-model="user_phone"
                placeholder="আপনার ফোন  নম্বর "
                v-if="globalLanguage == 'BN'"
              />
              <input
                type="text"
                class="form-control"
                v-model="user_phone"
                placeholder="Phone Number"
                v-else
              />
            </div>
            <div class="form-group">
              <textarea
                class="form-control"
                v-model="product_name_list"
                placeholder="প্ৰডাক্ট এর নাম লিখুন  যেমন: চাল,ডাল, পিয়াজ "
                v-if="globalLanguage == 'BN'"
              ></textarea>
              <textarea
                class="form-control"
                v-model="product_name_list"
                placeholder="Product Name List"
                v-else
              ></textarea>
            </div>
            <button
              class="btn btn-orange btn-sm"
              @click="productRequest"
              v-if="globalLanguage == 'BN'"
            >
              সেন্ড করুন
            </button>
            <button
              class="btn btn-orange btn-sm"
              @click="productRequest"
              v-else
            >
              Send Request
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--end  modal-->
  </div>
</template>
<script>
const $ = require("jquery");
window.$ = $;
$(function() {
  $(window).scroll(function() {
    $("nav").toggleClass("scrolled", $(this).scrollTop() > 20);
  });
});
import axios from "axios";
import CartData from "./CartData";
import { setSeo } from "@/seo";
import ProductCartControl from "./ProductCartControl";

export default {
  components: { CartData, ProductCartControl },
  data() {
    return {
      products: [],
      category: [],
      menuStatus: true,
      modalProductData: [],
      recentViews: [],
      get_category_name: "",
      get_sub_category_name: "",
      get_child_category_name: "",
      loadMore: true,
      isLoading: false,
      quantity: 1,
      images: [],
      changeModalGallery_image: "",
      categories: [],
      category_image: "",
      sub_categories: [],
      child_sub_categories: [],
      //carts  rlated  variables
      token: "",
      getcarts: [],
      carts: [],
      isOpen: true,
      sum_cart_total: "",
      cartsCountProduct: 0,
      parseCartData: [],
      activeItem: "",
      mainCategories: [],
      subCategories: [],
      language: "",
      childCategories: [],
      user_phone: null,
      product_name_list: null,
      wishlistIds: [],
      related_products: [],
      categoryTree: [],
      breadcrumb: []
    };
  },
  created: function() {
    //this.allCategory();
    //this.checkingCartProducts();
    this.language = this.globalLanguage;
    this.wishlistIds = this.getWishlist().map(x => x.id);
    window.addEventListener("wishlist-updated", this.refreshWishlistIds);
  },
  beforeDestroy() {
    window.removeEventListener("wishlist-updated", this.refreshWishlistIds);
  },
  mounted() {
    let vm = this;
    if (localStorage.getItem("token")) {
      let vm = this;
      vm.token = localStorage.getItem("token");
      vm.user_phone = JSON.parse(localStorage.getItem("userinfo")).phone;
    }
    if (localStorage.getItem("carts")) {
      vm.carts = JSON.parse(localStorage.getItem("carts"));
    } else {
      vm.carts = [];
    }
    this.calculateCartTotal();
    this.category_products();
    this.fetchCategoryTree();
    this.buildBreadcrumb();
  },
  watch: {
    $route() {
      this.category_products();
      this.buildBreadcrumb();
    }
  },
  methods: {
    fetchCategoryTree() {
      let vm = this;
      axios
        .get(this.globalUrl + "all-category-list")
        .then(function(response) {
          vm.categoryTree = response.data;
          vm.buildBreadcrumb();
        })
        .catch(response => {});
    },
    buildBreadcrumb() {
      let slug = this.$route.params.slug;
      // These sidebar links are static (not part of the category tree returned
      // by all-category-list), so they need a hardcoded crumb instead of a
      // tree lookup.
      const staticPages = {
        popular: { name: "Popular", name_bn: "জনপ্রিয়" },
        "flash-sales": { name: "Flash Sales", name_bn: "ফ্ল্যাশ সেলস" }
      };
      if (staticPages[slug]) {
        this.breadcrumb = [{ ...staticPages[slug], slug }];
        return;
      }
      let trail = [];
      outer: for (const main of this.categoryTree) {
        if (main.slug === slug) {
          trail = [{ name: main.cat_name, name_bn: main.cat_name_bn, slug: main.slug }];
          break outer;
        }
        for (const sub of main.sub_category || []) {
          if (sub.slug === slug) {
            trail = [
              { name: main.cat_name, name_bn: main.cat_name_bn, slug: main.slug },
              { name: sub.sub_cat_name, name_bn: sub.sub_cat_name_bn, slug: sub.slug }
            ];
            break outer;
          }
          for (const child of sub.child_sub_cats || []) {
            if (child.slug === slug) {
              trail = [
                { name: main.cat_name, name_bn: main.cat_name_bn, slug: main.slug },
                { name: sub.sub_cat_name, name_bn: sub.sub_cat_name_bn, slug: sub.slug },
                { name: child.child_cat_name, name_bn: child.child_cat_name_bn, slug: child.slug }
              ];
              break outer;
            }
          }
        }
      }
      this.breadcrumb = trail;
    },
    hasCartQuantity(productId) {
      const cart = this.carts.find(item => item.product_id == productId);
      return Boolean(cart && Number(cart.cart_quantity) > 0);
    },
    inWishlist(productId) {
      return this.wishlistIds.indexOf(productId) !== -1;
    },
    refreshWishlistIds() {
      this.wishlistIds = this.getWishlist().map(x => x.id);
    },
    toggleWishlistClick(product) {
      // toggleWishlist() dispatches "wishlist-updated" synchronously, which
      // refreshWishlistIds() picks up immediately — no need to also patch
      // wishlistIds here (doing so double-toggled it and showed the wrong icon).
      this.toggleWishlist(product);
    },
    assignProduct(product_name) {
      this.product_name_list = product_name;
      if (localStorage.getItem("user_phone")) {
        this.user_phone = localStorage.getItem("user_phone");
      }
    },
    productRequest() {
      axios
        .post(
          this.globalUrl + "product-request",
          {
            name: this.product_name_list,
            phone: this.user_phone
          },
          { crossdomain: true }
        )
        .then(response => {
          this.product_name_list = "";
          this.your_phone = "";
          this.$toasted.show(
            "Your Request Taken  successfully. We will contact with you soon",
            {
              type: "success",
              icon: "fa-check-circle",
              duration: 1000000
            }
          );
        })
        .catch(response => {
          console.log(response);
        });
    },
    toogleNav: function() {
      $(".small-device #sidebar-area").toggleClass("show");
      $("#content-area").toggleClass("fullwidth");
      $("#sidebar-area").toggleClass("hidden-sidebar");
      if (this.menuStatus == true) {
        this.menuStatus = false;
      } else if (this.menuStatus == false) {
        this.menuStatus = true;
      }
    },
    isActive: function(menuItem) {
      return this.activeItem === menuItem;
    },
    setActive: function(menuItem) {
      this.activeItem = menuItem; // no need for Vue.set()
    },
    increment(product_id) {
      //this.quantity++
      let objIndex = this.carts.findIndex(obj => obj.product_id == product_id);
      if (objIndex != -1) {
        let oldQuantity = this.carts[objIndex].cart_quantity;
        let stock_quantity = this.carts[objIndex].stock_quantity;
        if (this.quantity < stock_quantity) {
          let newQuantity = oldQuantity + 1;
          let price = this.carts[objIndex].price;
          this.carts[objIndex].cart_quantity = newQuantity;
          this.carts[objIndex].subtotal = price * newQuantity;
          localStorage.setItem("carts", JSON.stringify(this.carts));
          this.carts = JSON.parse(localStorage.getItem("carts"));
          $("#" + product_id + " .amountQuantity").text(newQuantity);
          this.calculateCartTotal();
          this.quantity = newQuantity;
        }
      } else {
        let objIndex = this.products.findIndex(obj => obj.id == product_id);
        let stock_quantity = Math.trunc(this.products[objIndex].stock_quantity);
        if (this.quantity < stock_quantity) {
          this.quantity++;
        } else {
          this.quantity;
        }
      }
    },
    decrement(product_id) {
      if (this.quantity === 1) {
      } else {
        this.quantity--;
        let objIndex = this.carts.findIndex(
          obj => obj.product_id == product_id
        );
        if (objIndex != -1) {
          let oldQuantity = this.carts[objIndex].cart_quantity;
          if (oldQuantity > 1) {
            let newQuantity = oldQuantity - 1;
            let price = this.carts[objIndex].price;
            this.carts[objIndex].cart_quantity = newQuantity;
            this.carts[objIndex].subtotal = price * newQuantity;
            localStorage.setItem("carts", JSON.stringify(this.carts));
            this.carts = JSON.parse(localStorage.getItem("carts"));
            this.calculateCartTotal();
            $("#" + product_id + " .amountQuantity").text(newQuantity);
          }
        }
      }
    },
    category_products: function() {
      let vm = this;
      let category_slug = this.$route.params.slug;
      vm.isLoading = true;
      axios
        .get(this.globalUrl + "category/" + category_slug)
        .then(function(response) {
          vm.products = [];

          console.log(response);
          vm.endLoading;

          vm.products = response.data.products;

          vm.category = response.data.category;
          if (vm.category && vm.category.cat_name) {
            setSeo({
              title: vm.category.cat_name,
              description:
                vm.category.description ||
                "Shop " + vm.category.cat_name + " online at SHAH PREMIUM FOODS. Fresh, quality products with fast home delivery."
            });
          }

          vm.sub_categories = response.data.sub_categories;
          vm.isLoading = false;

          $(".button-label").removeClass("cartAdded");
          vm.$nextTick(function() {
            vm.syncCartButtons();
          });
        })
        .catch(response => {
          vm.$toasted.show("Something wrong  Refresh  again.", {
            type: "error",
            icon: "fa-exclamation-triangle"
          });
        });
    },
    syncCartButtons: function() {
      this.carts.forEach(function(cart) {
        $("#product_" + cart.product_id).addClass("cartAdded");
        $("#product_" + cart.product_id + " .amountQuantity").text(
          cart.cart_quantity
        );
        $("#q_product_" + cart.product_id + " .cartsection").addClass(
          "cartAdded"
        );
        $("#q_product_" + cart.product_id + " .amountQuantity").text(
          cart.cart_quantity
        );
      });
    },
    quickView: function(index) {
      let vm = this;
      vm.modalProductData = this.products[index];
      //this  is  used  for  just chnage  folder  for  gallery  image and  featured  image in  moddal
      vm.changeModalGallery_image = this.products[index].featured_image;
      let productID = vm.modalProductData.id;
      //console.log(productID);
      const result = this.carts.find(function(obj) {
        return obj.product_id == productID;
      });

      if (result === undefined) {
        vm.quantity = 1;
      } else {
        let oldQuantity = result.cart_quantity;
        vm.quantity = oldQuantity;
      }
      vm.related_products = [];
      axios
        .get(this.globalUrl + "products/" + productID)
        .then(function(response) {
          vm.related_products = response.data.related_products;
        })
        .catch(response => {});
    },
    viewRelatedProduct(product_id) {
      let vm = this;
      const result = this.carts.find(obj => obj.product_id == product_id);
      vm.quantity = result ? result.cart_quantity : 1;
      axios
        .get(this.globalUrl + "products/" + product_id)
        .then(function(response) {
          vm.modalProductData = response.data.product;
          vm.changeModalGallery_image = response.data.product.featured_image;
          vm.related_products = response.data.related_products;
        })
        .catch(response => {
          vm.$toasted.show("Something wrong  Try again.", {
            type: "error",
            icon: "fa-exclamation-triangle"
          });
        });
    },
    getCartQuantity(productId) {
      const cart = this.carts.find(item => item.product_id == productId);
      return cart ? cart.cart_quantity : 0;
    },
    addOrIncrementRelatedCart(product) {
      if (product.stock_quantity < 1) {
        this.$toasted.show("Out of Stock. Not Added In your Bag.", {
          type: "error",
          icon: "fa-exclamation-triangle",
          position: "bottom-left"
        });
        return;
      }
      let exists =
        this.carts.findIndex(obj => obj.product_id == product.id) !== -1;
      if (exists) {
        this.cartIncrement(product.id);
      } else {
        this.addRelatedToCart(product);
      }
    },
    addRelatedToCart(product) {
      let vm = this;
      let exists =
        this.carts.findIndex(obj => obj.product_id == product.id) !== -1;
      if (exists) {
        this.cartIncrement(product.id);
        return;
      }
      let result = JSON.parse(localStorage.getItem("carts"));
      if (result == null) result = [];
      let price = product.price - product.discount;
      result.unshift({
        product_id: product.id,
        product_name: product.name,
        product_name_bn: product.name_bn,
        product_image: product.featured_image,
        price: price,
        image: product.featured_image,
        quantity: product.unit_quantity,
        unit: product.unit,
        cart_quantity: 1,
        stock_quantity: product.stock_quantity,
        subtotal: price * 1
      });
      localStorage.setItem("carts", JSON.stringify(result));
      vm.carts = JSON.parse(localStorage.getItem("carts"));
      this.calculateCartTotal();
      vm.$toasted.show("New Product Added In your Bag.", {
        type: "success",
        icon: "fa-check-circle",
        position: "bottom-left"
      });
    },
    //carts  related  functions
    cartIncrement(product_id) {
      //alert(product_id);
      let vm = this;
      let objIndex = this.carts.findIndex(obj => obj.product_id == product_id);
      let oldQuantity = this.carts[objIndex].cart_quantity;
      let stock_quantity = this.carts[objIndex].stock_quantity;
      if (oldQuantity < stock_quantity) {
        let newQuantity = oldQuantity + 1;
        let price = this.carts[objIndex].price;
        this.carts[objIndex].cart_quantity = newQuantity;
        this.carts[objIndex].subtotal = price * newQuantity;
        localStorage.setItem("carts", JSON.stringify(this.carts));
        this.carts = JSON.parse(localStorage.getItem("carts"));
        $("#product_" + product_id + " .amountQuantity").text(newQuantity);
        $("#q_product_" + product_id + " .amountQuantity").text(newQuantity);
        this.calculateCartTotal();
        $("#product_" + product_id).addClass("animated");
        $("#q_product_" + product_id).addClass("animated");
        setTimeout(function() {
          $("#product_" + product_id).removeClass("animated");
          $("#q_product_" + product_id).removeClass("animated");
        }, 500);
      } else {
        vm.$toasted.show(
          "<span>" +
            stock_quantity +
            "</span>" +
            "Quantity is available, Please call for more Quantity.",
          {}
        );
      }
    },
    cartDecrement(product_id) {
      let objIndex = this.carts.findIndex(obj => obj.product_id == product_id);
      let oldQuantity = this.carts[objIndex].cart_quantity;
      if (oldQuantity > 1) {
        let newQuantity = oldQuantity - 1;
        let price = this.carts[objIndex].price;
        this.carts[objIndex].cart_quantity = newQuantity;
        this.carts[objIndex].subtotal = price * newQuantity;
        localStorage.setItem("carts", JSON.stringify(this.carts));
        this.carts = JSON.parse(localStorage.getItem("carts"));
        this.calculateCartTotal();
        $("#product_" + product_id + " .amountQuantity").text(newQuantity);
        $("#q_product_" + product_id + " .amountQuantity").text(newQuantity);
        $("#product_" + product_id).addClass("animated");
        $("#q_product_" + product_id).addClass("animated");
        setTimeout(function() {
          $("#product_" + product_id).removeClass("animated");
        }, 500);
      } else if (oldQuantity == 1) {
        this.carts = this.carts.filter(e => e.product_id !== product_id);
        $("#product_" + product_id).removeClass("cartAdded");
        $("#q_product_" + product_id + " .cartsection").removeClass(
          "cartAdded"
        );
        localStorage.setItem("carts", JSON.stringify(this.carts));
        this.calculateCartTotal();
      }
    },
    removeCartItem: function(product_id) {
      //alert(product_id);
      this.carts = this.carts.filter(e => e.product_id !== product_id);
      $("#product_" + product_id).removeClass("cartAdded");
      localStorage.setItem("carts", JSON.stringify(this.carts));
      this.calculateCartTotal();
    },
    addOrIncrementCart(index, product_id) {
      if (this.products[index].stock_quantity < 1) {
        this.$toasted.show("Out of Stock. Not Added In your Bag.", {
          type: "error",
          icon: "fa-exclamation-triangle",
          position: "bottom-left"
        });
        return;
      }
      let exists =
        this.carts.findIndex(obj => obj.product_id == product_id) !== -1;
      if (exists) {
        this.cartIncrement(product_id);
      } else {
        this.createCarts(index, product_id);
      }
    },
    createCarts: function(index, product_id) {
      let vm = this;
      let thisProductID = product_id;
      $("#product_" + product_id + " .amountQuantity").text(1);
      $("#q_product_" + product_id + " .amountQuantity").text(1);
      //alert(thisProductID);
      //check  array  index  product  info
      //console.log(this.products[index]);
      let check_if_cart_item_exist = this.carts.findIndex(
        x => x.product_id === this.products[index].id
      );

      if (check_if_cart_item_exist >= 0) {
        $("#product_" + thisProductID).addClass("cartAdded");
        $("#q_product_" + thisProductID + " .cartsection").addClass(
          "cartAdded"
        );
        let objIndex = this.carts.findIndex(
          x => x.product_id === this.products[index].id
        );
        let oldQuantity = this.carts[objIndex].cart_quantity;
        $("#product_" + thisProductID + " .amountQuantity").text(oldQuantity);
        $("#q_product_" + thisProductID + " .amountQuantity").text(oldQuantity);
      } else {
        $("#product_" + thisProductID).addClass("cartAdded");
        $("#q_product_" + thisProductID + " .cartsection").addClass(
          "cartAdded"
        );
        //console.log(this.products[index].id);
        let result = JSON.parse(localStorage.getItem("carts"));
        if (result == null) result = [];
        let price = this.products[index].price - this.products[index].discount;
        //console.log(price);
        result.unshift({
          product_id: this.products[index].id,
          product_name: this.products[index].name,
          product_name_bn: this.products[index].name_bn,
          product_image: this.products[index].featured_image,
          price: price,
          image: this.products[index].featured_image,
          quantity: this.products[index].unit_quantity,
          unit: this.products[index].unit,
          cart_quantity: 1,
          stock_quantity: this.products[index].stock_quantity,
          subtotal: price * 1
        });
        // save the new result array
        localStorage.setItem("carts", JSON.stringify(result));
        vm.carts = JSON.parse(localStorage.getItem("carts"));
        this.calculateCartTotal();
        vm.$toasted.show("New Product Added In your Bag.", {
          type: "success",
          icon: "fa-check-circle",
          position: "bottom-left"
        });
        $(".carts").addClass("animated zoomIn");
        $(".cart_amount").addClass("shadow-pulse");
        setTimeout(function() {
          $(".carts").removeClass("animated zoomIn");
          $(".cart_amount").removeClass("shadow-pulse");
        }, 5000);
      }
    },

    createCartsModal: function() {
      let vm = this;
      let this_product_quantity = vm.quantity;
      let singleProduct = vm.modalProductData;
      // alert(singleProduct.id);
      let check_if_cart_item_exist = this.carts.findIndex(
        x => x.product_id === singleProduct.id
      );
      if (check_if_cart_item_exist >= 0) {
        vm.$toasted.show("Already Added In your Bag.", {
          type: "error",
          icon: "fa-exclamation-triangle",
          position: "bottom-left"
        });
      } else {
        let result = JSON.parse(localStorage.getItem("carts"));
        if (result == null) result = [];
        let price = singleProduct.price - singleProduct.discount;
        if (this_product_quantity <= singleProduct.stock_quantity) {
          this_product_quantity = this_product_quantity;
        } else {
          this_product_quantity = Math.trunc(singleProduct.stock_quantity);
        }
        result.unshift({
          product_id: singleProduct.id,
          product_name: singleProduct.name,
          product_name_bn: singleProduct.name_bn,
          product_image: singleProduct.featured_image,
          price: price,
          image: singleProduct.featured_image,
          cart_quantity: this_product_quantity,
          quantity: singleProduct.unit_quantity,
          unit: singleProduct.unit,
          stock_quantity: singleProduct.stock_quantity,
          subtotal: price * this_product_quantity
        });
        // save the new result array
        localStorage.setItem("carts", JSON.stringify(result));
        vm.carts = JSON.parse(localStorage.getItem("carts"));
        this.calculateCartTotal();
        vm.$toasted.show("New Product Added In your Bag.", {
          type: "success",
          icon: "fa-check-circle",
          position: "bottom-left"
        });
      }
    },
    calculateCartTotal() {
      let vm = this;
      for (
        var i = 0, sum = 0;
        i < vm.carts.length;
        sum += vm.carts[i++].subtotal
      );
      vm.sum_cart_total = sum;
      for (
        var i = 0, totalSum = 0;
        i < vm.carts.length;
        totalSum += vm.carts[i++].cart_quantity
      );
      vm.cartsCountProduct = totalSum;
      localStorage.setItem("cartsCountProduct", totalSum);
      $(".carts .badge").text(vm.carts.length);
    },
    galleryImg: function(image_url) {
      let vm = this;
      vm.changeModalGallery_image = image_url;
    }
  }
};
</script>

<style scoped>
/* Ensure breadcrumb and category block have spacing */
.category-block {
  padding: 5px 15px;
}
.category-block .breadcum {
  margin-bottom: 12px;
  padding-left: 6px;
}
.category-block .col-md-12 + .col-lg-3 {
  margin-top: 6px;
}

.summary {
  padding-left: 10px;
}

.related-products-section {
  padding: 0 15px 10px;
}

.related-products-section hr {
  margin-top: 0;
}

.related-title {
  margin: 0 0 15px;
  font-size: 16px;
  font-weight: 600;
  color: #000;
}

.related-products-scroll {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 8px;
  scrollbar-width: thin;
}

.related-products-scroll::-webkit-scrollbar {
  height: 6px;
}

.related-products-scroll::-webkit-scrollbar-thumb {
  background: #e0e0e0;
  border-radius: 6px;
}

.related-product-card {
  flex: 0 0 140px;
  width: 140px;
  border: 1px solid #eee;
  border-radius: 8px;
  cursor: pointer;
  background: #fff;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.related-product-card:hover {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.related-product-img {
  position: relative;
  height: 110px;
  padding: 8px;
}

.related-product-img img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.related-product-info {
  padding: 0 10px 10px;
}

.related-product-price {
  color: #f89406;
  font-weight: 600;
  font-size: 13px;
}

.related-product-name {
  font-size: 12px;
  color: #333;
  margin-top: 2px;
  line-height: 1.3;
}

</style>
